import { ReactNode } from "react";
import { ArrowRightIcon } from "@heroicons/react/20/solid";

import { clsxMerge } from "shared/lib/helpers";
import Container from "@/components/base/container";
import Router from "@/helpers/router";
import { UTMLink } from "@/components/base/utm-link";
import { handleCalendlyPopup } from "@/helpers/calendly";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface CallToActionPropsI {
  className?: string;
  title?: ReactNode;
  titleClassName?: string;
  body?: ReactNode;
  bodyClassName?: string;
  primaryCTA?: ReactNode;
  secondaryCTA?: ReactNode;
  buttonsClassName?: string;
}

export const CallToAction = ({
  className,
  title,
  titleClassName,
  body,
  bodyClassName,
  primaryCTA,
  secondaryCTA,
  buttonsClassName,
}: CallToActionPropsI) => (
  <div className={clsxMerge("flex flex-col items-center", className)}>
    {title && (
      <h1
        className={clsxMerge(
          "mb-6 text-center typography-header-5-semibold",
          "sm:typography-header-3",
          "lg:typography-header-2",
          titleClassName
        )}
      >
        {title}
      </h1>
    )}

    {body && (
      <p
        className={clsxMerge(
          "mb-[52px] typography-body-3",
          "sm:typography-header-7 md:mb-4",
          bodyClassName
        )}
      >
        {body}
      </p>
    )}

    <div
      className={clsxMerge(
        "flex w-full flex-col items-center justify-center gap-[21px] sm:flex-row md:gap-[31px]",
        buttonsClassName
      )}
    >
      {primaryCTA}
      {secondaryCTA}
    </div>
  </div>
);

export const MoreSalesQualifiedMeetingsCTA = ({
  className,
}: PropsWithClassNameI) => (
  <section className={className}>
    <Container className={clsxMerge("flex flex-col items-center text-center")}>
      <CallToAction
        className="max-w-[764px]"
        title="More sales qualified meetings are just a click away"
        titleClassName="max-w-[329px] sm:max-w-[509px] md:max-w-[782px] mb-[58px] md:mb-[34px]"
        primaryCTA={
          <button className="btn-lg-highlighted" onClick={handleCalendlyPopup}>
            Start growing your pipeline
          </button>
        }
        secondaryCTA={
          <div
            className="link typography-header-8-semibold"
            onClick={handleCalendlyPopup}
          >
            Request a demo <ArrowRightIcon className="ml-1 w-5" />
          </div>
        }
      />
    </Container>
  </section>
);

export const GettingMoreQualifiedMeetingsCTA = ({
  className,
}: PropsWithClassNameI) => (
  <section className={className}>
    <Container className={clsxMerge("flex flex-col items-center text-center")}>
      <CallToAction
        className="max-w-[764px]"
        title="Earn commissions today"
        titleClassName="max-w-[340px] md:max-w-[720px]"
        primaryCTA={
          <UTMLink
            href={Router.applyQualify()}
            className="btn-lg-highlighted w-[246px]"
          >
            Apply to start calling
          </UTMLink>
        }
      />
    </Container>
  </section>
);
